import React from 'react';
import { TextInput } from '@carbon/react';

const FileQueuerSettings: React.FC = () => (
  <>
    <div className="settings-page__form-grid">
      <TextInput id="filequeuer-slots" labelText="Parallel slots" placeholder="4" />
      <TextInput id="filequeuer-throttle" labelText="Throttle (MB/s)" placeholder="120" />
    </div>
  </>
);

export default FileQueuerSettings;
